export default __webpack_public_path__ + "b29f1db18d19856059a17e75835555f1.png";